import { render, staticRenderFns } from "./ltzjjx8.vue?vue&type=template&id=54ef66db&scoped=true&"
import script from "./ltzjjx8.vue?vue&type=script&lang=js&"
export * from "./ltzjjx8.vue?vue&type=script&lang=js&"
import style0 from "./ltzjjx8.vue?vue&type=style&index=0&id=54ef66db&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ef66db",
  null
  
)

export default component.exports